import { Injectable } from '@angular/core';
import { AppSettingsService } from '../config/config-service';
import { CommonService } from './common.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface PresignResponse {
  key: string;
  uploadUrl: string;
  url?: string;
  expiresIn?: number;
}

@Injectable({ providedIn: 'root' })
export class UploadService {
  private apiUrl: string;

  constructor(
    private http: CommonService,
    private appSettingsService: AppSettingsService
  ) {
    this.apiUrl = this.appSettingsService.getSettings().apiEndPoint || '';
  }

  getPresign(file: File): Observable<PresignResponse> {
    const body = {
      fileName: file.name,
      contentType: file.type || 'application/octet-stream',
      size: file.size
    };
    return this.http.post<{ success: boolean; data: PresignResponse }>(`${this.apiUrl}/api/uploads/presign`, body)
      .pipe(
        // unwrap data to match PresignResponse shape
        (source) => new Observable<PresignResponse>(subscriber => source.subscribe({
          next: (resp) => {
            if (resp && resp.data) {
              subscriber.next(resp.data);
              subscriber.complete();
            } else {
              subscriber.error(new Error('Invalid presign response'));
            }
          },
          error: (e) => subscriber.error(e)
        })),
        catchError(err => throwError(() => err))
      );
  }

  async putToS3(uploadUrl: string, file: File): Promise<void> {
    const res = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type || 'application/octet-stream'
      },
      body: file
    });
    if (!res.ok) {
      throw new Error(`S3 upload failed: ${res.status}`);
    }
  }
}
